<mat-spinner *ngIf="isLoading" [diameter]="26"></mat-spinner>

<button mat-icon-button [matMenuTriggerFor]="notifMenu" *ngIf="!isLoading">
  <mat-icon aria-label="Notifications" matBadgeColor="warn" *ngIf="notifications.length > 0"
    [matBadge]="notifications.length" [matBadgeHidden]="notifications.length === 0">
    notifications
  </mat-icon>
  <mat-icon aria-label="No notification" *ngIf="notifications.length === 0">
    notifications_none
  </mat-icon>
</button>

<mat-menu #notifMenu="matMenu" class="notif-menu">
  <ul *ngIf="notifications.length > 0" class="notificationWrapper">
    <li *ngFor="let notification of notifications; index as i" (click)="$event.stopPropagation(); clearOne(i)">
      <ng-container *ngIf="notification.type === 6">
        Votre fichier est prêt sur <a routerLink="/documents">votre page de documents</a>
      </ng-container>

      <ng-container *ngIf="notification.type === 7">
        La commande {{notification.payload.orderIdentifier}}
        <span [ngClass]="{ 'redBold': notification.payload.reminder === 2 }">
          est en retard <span *ngIf="notification.payload.reminder === 2">(>= 10 min)</span>
        </span>
      </ng-container>
    </li>

    <li class="actions">
      <button mat-button color="primary" (click)="onClear()">
        Tout marquer comme lu
      </button>
    </li>

  </ul>

  <p *ngIf="notifications.length === 0">Vous n'avez aucune notification.</p>

</mat-menu>